import { FormProvider, useFormContext } from 'react-hook-form';

import Typography from 'components/global/Typography';

import { FormHeader } from '../OTOLinkBuyer';
import * as S from './Tabs.styled';

const OrderSummary = () => {
	const formMethods = useFormContext();
	const { watch } = formMethods;

	return (
		<FormProvider {...formMethods}>
			<S.OrderSummaryContainer>
				<S.Card padding={0} background border={0} shadowed rounded>
					<S.OrderSummaryContent>
						<FormHeader title="paymentSummary" />
						<S.OrderSummaryList>
							{watch('orderItems')?.map((item, index, arr) => (
								<S.OrderSummaryRow key={index} $bottomLine={index === arr.length - 1}>
									<Typography color="var(--content-1)" fontWeight="500">
										{item.quantity}x {item.name}
									</Typography>
									<Typography
										withCurrency
										currency={watch('currency')}
										color="var(--content-1)"
										fontWeight="500">
										{item.total}
									</Typography>
								</S.OrderSummaryRow>
							))}
						</S.OrderSummaryList>

						<S.OrderSummaryRow>
							<Typography color="var(--content-3)">subtotal</Typography>
							<Typography withCurrency currency={watch('currency')} color="var(--content-3)">
								{watch('subTotal') || 0}
							</Typography>
						</S.OrderSummaryRow>
						<S.OrderSummaryRow>
							<Typography color="var(--content-3)">paymentSummary.shippingFee</Typography>
							<Typography
								withCurrency={watch('shippingFee') !== null}
								currency={watch('currency')}
								color={watch('shippingFee') === null ? 'var(--content-4)' : 'var(--content-3)'}>
								{watch('shippingFee') || 'calculatedAtCheckout'}
							</Typography>
						</S.OrderSummaryRow>

						<S.OrderSummaryRow $topLine>
							<Typography fontWeight="500" color="var(--content-1)">
								grandTotal
							</Typography>
							<Typography
								fontWeight="500"
								color="var(--content-1)"
								withCurrency
								currency={watch('currency')}>
								{watch('grandTotal') || 0}
							</Typography>
						</S.OrderSummaryRow>
					</S.OrderSummaryContent>
				</S.Card>
			</S.OrderSummaryContainer>
		</FormProvider>
	);
};

export default OrderSummary;
